import React from 'react';
import Form from 'react-bootstrap/Form';
import { Col, Row, Table } from 'react-bootstrap';

export default function SetupStep4(props) {
    const formatThemeYesNo = (programId, sloId, themeId) => {
        let key = 'program-' + programId + '_slo-' + sloId + '_theme-' + themeId
        if (key in props.learningOutcomeMappings) {
            return formatYesNo(props.learningOutcomeMappings[key])
        } else {
            return 'No'
        }
    }

    const formatYesNo = (val) => {
        let formattedValue = ''
        if (val === 'yes') {
            formattedValue = 'Yes'
        } else {
            formattedValue = 'No'
        }
        return formattedValue
    }

    let department
    let departmentId

    if (props.departmentId) {
        department = props.departments.find((d) => d.departmentId == props.departmentId)
        departmentId = props.departmentId
    } else if (props.departments) {
        department = props.departments.find((d) => d.departmentId == props.department.departmentId)
        departmentId = props.department.departmentId
    }
    
    let programs = department.programList
    let learningOutcomes = props.programLearningOutcomes
    
    return (
        <div className="row row-cols-1 row-cols-md-1">
            <div className="p-5 text-center">
                <h3>Review and Submit Completed Setups</h3>
            </div>
            <div className="text-center pb-4">
                <Row>
                    <Col md="4">
                        <span className="fs-4 m-3">Department</span>
                    </Col>
                    <Col md="8">
                        <span className="fs-4 text-muted">{department?.longName}</span>
                    </Col>
                </Row>
            </div>
            <div className="p-3">
                <h4>Identify Programs/Gen Ed areas to Assess</h4>
                <Table striped>
                    <thead>
                        <tr>
                            <th>Programs</th>
                            <th className="mx-auto text-center">
                                Select Programs/Gen Ed areas to set up
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            Object.keys(props.activePrograms).map((key, index) => (
                                <tr key={index}>
                                    <td className="py-3">{(department.programList.find(p => p.programId == key)).longName}</td>
                                    <td className="mx-auto text-center">
                                        <Form.Label>
                                            {formatYesNo(props.activePrograms[key])}
                                        </Form.Label>
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </Table>
            </div>
            <div className="p-3">
                <h4>Map Learning Outcomes to Universal Themes</h4>
                {
                    Object.keys(props.activePrograms).map((key, index) =>
                        <div key={index}>
                            <Table>
                                <thead>
                                    <tr>
                                        <th>{(department.programList.find(p => p.programId == key)).longName}</th>
                                        <th className="text-center">Thinking in Action</th>
                                        <th className="text-center">Practicing Community</th>
                                        <th className="text-center">Professional Skills</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        learningOutcomes[key].map((slo, index2) =>
                                            <tr key={index2}>
                                                <td>{slo.text}</td>
                                                <td className="text-center">
                                                    <Form.Label>
                                                        {formatThemeYesNo(key, slo.sloId, 1)}
                                                    </Form.Label>
                                                </td>
                                                <td className="text-center">
                                                    <Form.Label>
                                                        {formatThemeYesNo(key, slo.sloId, 2)}
                                                    </Form.Label>
                                                </td>
                                                <td className="text-center">
                                                    <Form.Label>
                                                        {formatThemeYesNo(key, slo.sloId, 3)}
                                                    </Form.Label>
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </Table>
                        </div>
                    )
                }
            </div>

            <div className="p-3">
                <h4>Finalize Mappings</h4>
                <Table>
                    <thead>
                        <tr>
                            <th>Program</th>
                            <th className="text-center">
                                Final mapping ready to be submitted
                            </th>
                            <th>Submitted By</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            Object.keys(props.activePrograms).map((key, index) =>
                                <tr key={index}>
                                    <td className="py-3"
                                        style={{width: "60%"}}
                                        >
                                        {department.programList.find(p => p.programId == key).longName}
                                    </td>
                                    <td className="text-center"
                                        style={{width: "20%"}}>
                                        <Form.Label>
                                            {formatYesNo(props.submittedPrograms[key])}
                                        </Form.Label>
                                    </td>
                                    <td className=""
                                        style={{width: "20%"}}>
                                        <Form.Label>
                                            {props.submittedUsers[key]}
                                        </Form.Label>
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table>
            </div>

            <div className="p-3" style={{margin: "auto", width: "70%"}}>
                <p className="fs-6 text-muted">
                    After clicking 'Save', the assessment process can begin for all
                    programs marked here as having a final mapping ready to be submitted.
                    Assessment of the remaining programs can only begin after they have a 
                    mapping finalized and saved here. Finalized mappings that have already
                    been saved here can be revised only by contacting the assessment support 
                    team for assistance: <a href="mailto:assessment@cnm.edu">assessment@cnm.edu</a>
                </p>
            </div>
        </div>
    )
}
